import * as actions from "../actions/index";
import api from "../api";
import { store } from "..";
import { addErrorAlert } from "./alertLoadingDispatch";
import { toggleGlobalLoader } from "../actions/session";

let updateOD = actions.indicativeOptionData.updateIndicativeOptionData;

export const getBusinessTypes = () => {
  return api.get("/business-types/").then((res) => {
    store.dispatch(updateOD({ businessTypes: res.data }));
  });
};

export const getAssetTypes = () => {
  return api.get("/asset-types/").then((res) => {
    store.dispatch(updateOD({ assetTypes: res.data }));
  });
};

export const getAvailableImprovements = () => {
  return api
    .get("/improvements/")
    .then((res) => {
      store.dispatch(updateOD({ improvements: res.data }));
    })
    .catch(() => addErrorAlert("Failed to pull improvements."));
};

//  where leadFieldData is data that is not in the json lead field. All json lead field stuff is pulled out of the reducer.

export const updateOrCreateProjectLead = (data) => {

    toggleGlobalLoader(true);
    let promise;
    if (data.data.id) {
         promise = () => api.patch(`/project-leads/${data.data.id}/`, data)
    } else {
         promise = () => api.post('/project-leads/', data)
    }

    return promise()
        .then((res) => {
            toggleGlobalLoader(false);
            return res;
        })
        .catch((err) => {
            toggleGlobalLoader(false);
            addErrorAlert("The project failed to update on our servers.")
            return err
        })
}


export const getProjectLead = id => {
    toggleGlobalLoader(true);
    return new Promise((resolve, reject) => {
         return api.get(`/project-leads/${id}/`)
             .then((res) => {
                 toggleGlobalLoader(false);
                 return resolve(res.data)
             })
             .catch((err) => {
                 toggleGlobalLoader(false);
                 addErrorAlert("The project failed to update on our servers.")
                 return reject(err)
             })
    })
}
